var NeatolabsNeatolabsCart = {
    // ---------------------------------------------------
    // Handle Add to Cart
    // ---------------------------------------------------
    
    updatePage : (product) => {
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/products/${product.handle}?variant=${product.variants[0].id}`;
    },
    
    
    remove : async (variantId)=> {
        await fetch(`/cart/change?id=${variantId}&quantity=0`)
    },
    
    shopifyAddToCart: async (data) => {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: data
            })
        })
    },
    add : async (data)=> {
        console.groupCollapsed('%cCustomization Data:', 'background: #79bc61; color: white; font-size: 14px; padding: 15px 25px 15px 25px; border-radius: 3px;');
        //console.log(data);
        console.groupEnd();
        
        
        // Close the modal
        Neatolabs.control.modal.closeModal();
        
        const properties = data.properties;
        const productId = data.new_product.id
        const variantId = data.new_product.variants[0].id
        let quantity = data.quantity
        const isModified = data.is_modified
        
        if (isModified) {
            const product = Neatolabs.data.collection[Neatolabs.data.activeUuid]
            await NeatolabsNeatolabsCart.remove(product.variant_id)
        }
        await NeatolabsNeatolabsCart.shopifyAddToCart([{
            ['id']: variantId,
            ['quantity']: quantity,
            ['properties']: properties,
            ['product-id']: productId
        }])
        NeatolabsNeatolabsCart.updatePage(data.new_product);
        
    },
}